import React, { useState } from "react";
import { Alert } from "reactstrap";
import { deactivateMFA } from "../../../services/AccountApi";
import { checkMFA } from "../../../services/AccountApi";
import { useAccountTranslation } from "../translations";

interface Props {

}

interface Actions {
    setMfaSetUp: (n: number) => void;
    setMfaQr: (n: string) => void;
}


const DeleteMfa: React.FC<Props & Actions> = ({ setMfaSetUp, setMfaQr }) => {

    const [otp, setOtp] = useState<string>("")
    const [password, setPassword] = useState<string>("")
    const [error, setError] = useState<string | null>(null)
    const { t } = useAccountTranslation();

    return <div className="portal-mfa-verify">
            <div>
                <strong>{t("deactivateMfa")}</strong>
                <p>{t("mfaDeactivateDescription")}</p>
            </div>
            {error && <Alert color="danger">{error}</Alert>}
            <div className="portal-settings-field-grid">
                <label>
                    <span>{t("otp")}</span>
                    <input type="text" inputMode="numeric" autoComplete="one-time-code" value={otp}
                        onChange={event => setOtp(event.target.value)} />
                </label>
                <label>
                    <span>{t("password")}</span>
                    <input type="password" autoComplete="current-password" value={password}
                        onChange={event => setPassword(event.target.value)} />
                </label>
            </div>
            <div className="portal-button-row">
                <button
                    type="button"
                    onClick={() => {
                        deactivateMFA(password, { "totp": otp }).then(() => {
                            checkMFA().then((code) => {
                                //@ts-ignore
                                setMfaQr(code.mfa_qr)
                                setMfaSetUp(1)
                            }).catch(() => {
                                setError(t("mfaCredentialsError"))
                            })
                        }).catch(() => {
                            setError(t("mfaCredentialsError"))
                        })
                    }}
                    disabled={!otp.trim() || !password}
                    className="portal-button portal-button-danger"
                >
                    {t("confirm")}
                </button>
                <button
                    type="button"
                    onClick={() => setMfaSetUp(3)}
                    className="portal-button portal-button-secondary"
                >
                    {t("cancel")}
                </button>
            </div>
        </div>;
};

export default DeleteMfa;
